<template>
  <div class="buttons my-3 is-center">
    <button
      class="button is-primary"
      v-on:click="pageDown"
      :disabled="pagination.pageIndex == 1"
    >
      قبلی
    </button>

    <input
      v-model.number.lazy="pagination.pageIndex"
      class="input is-autowidth max-w-16 text-center"
    />
    <button
      class="button is-primary"
      v-on:click="pageUp"
      :disabled="
        pagination.pageIndex >=
        Math.ceil(props.totalItems / pagination.pageSize)
      "
    >
      بعدی
    </button>
  </div>
</template>
<script setup>
import router from "@/router";
import { defineProps, defineEmits, ref, watch } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();
const props = defineProps(["totalItems"]);
const emit = defineEmits(["setPagination"]);

const pagination = ref({
  pageSize: route.query.pageSize ?? 10,
  pageIndex: route.query.pageIndex ?? 1,
  searchKey: null,
});

function pageUp() {
  if (
    pagination.value.pageIndex <
    Math.ceil(props.totalItems / pagination.value.pageSize)
  ) {
    pagination.value.pageIndex++;
  }
}
function pageDown() {
  if (pagination.value.pageIndex > 1) {
    pagination.value.pageIndex--;
  }
}

watch(
  () => [pagination.value.pageIndex, pagination.value.pageSize],
  () => {
    router.push({
      name: route.name,
      params: route.params,
      query: {
        pageIndex: pagination.value.pageIndex,
        pageSize: pagination.value.pageSize,
      },
    });
    emit("setPagination", pagination.value);
  }
);

emit("setPagination", pagination.value);
</script>
